// extracted by mini-css-extract-plugin
export default {"spinner":"SmallRippleSpinner_spinner__EJNy0","animloader":"SmallRippleSpinner_animloader__OaPF1"};